$(function () {
  var screenQuery = window.matchMedia("(max-width: 1023px)");
  var $subNav = $(".site-nav .open-sub");
  var $flags = $(".flags .main-flag");
  const $footerSubNav = $(".site-footer-top_2025 .nav-footer-list-title");

  SiteNavigation();

  $(window).on("resize", function () {
    screenQuery;
    SiteNavigation();
  });

  $subNav.each(function (index) {
    $(this).on("click", function (e) {
      if (screenQuery.matches) {
        if ($(this).next(":visible").length == 1) {
          $(this).next().slideUp(200);
          $(this).parent().removeClass("opened");
        } else {
          $(this).next().slideDown(200);
          $(this).parent().addClass("opened");
        }
      }
    });
  });

  $flags.on("click", function (e) {
    if (screenQuery.matches) {
      if ($(this).find(".flag-list:visible").length == 1) {
        $(this).find(".flag-list").slideUp();
        $(this).parent().removeClass("opened");
      } else {
        $(this).find(".flag-list").slideDown();
        $(this).parent().addClass("opened");
      }
    }
  });

  $footerSubNav.each(function (index) {
    $(this).on("click", function (e) {
      if (screenQuery.matches) {
        if ($(this).next(":visible").length == 1) {
          $(this).next().slideUp(200);
          $(this).parent().removeClass("opened");
        } else {
          $(this).next().slideDown(200);
          $(this).parent().addClass("opened");
        }
      }
    });
  });

  $("body").on("click", ".btn-mob-menu", function (e) {
    e.preventDefault();
    $("body").toggleClass("site-menu-toggled");
  });

  function SiteNavigation() {
    if (!screenQuery.matches) {
      $("body").removeClass("site-menu-toggled");
      $(".site-nav .sub-nav-list, .site-nav .sub-nav, .site-nav .flag-list, .site-footer-top_2025 .nav-footer-list-items").css("display", "");
      $(".site-nav .open-sub").parent().removeClass("opened");
      $(".site-nav .flags").removeClass("opened");
      $(".site-footer-top_2025 .nav-footer-list-title").parent().removeClass("opened");
    }

    $(".site-nav .sub-nav-list").each(function () {
      var parentWidth = $(this).outerWidth();

      if (screenQuery.matches) {
        $(this).find(".sub-nav").css({ "padding-left": "" });
      } else {
        $(this)
          .find(".sub-nav")
          .css({ "padding-left": parentWidth + "px" });
      }
    });
  }
});
